<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-做任务-修改
    -->
    <el-dialog
    title="任务记录详情"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form"  label-width="100px">
  
      <!-- <el-form-item label="任务分类">
     
          {{ form.dotask.category.name }}
        </el-form-item> -->

      <el-form-item label="任务名称" prop="name">
        {{ form.dotask.name }}
      </el-form-item>

      <el-form-item label="任务简介" prop="name">
        {{ form.dotask.intro }}
      </el-form-item>
    
 
      <el-form-item label="任务类型">
        <span v-if="form.dotask.code == 'common'">普通任务</span>
        <span v-if="form.dotask.code == 'sport'">微信运动任务</span>

      </el-form-item>

      <el-form-item label="任务积分奖励">
        {{ form.dotask.point }}
      </el-form-item>  

      <div class="common-form">用户信息</div>

      <el-form-item label="昵称" prop="name">
        {{ form.user.nickName }}
      </el-form-item>

      <el-form-item label="手机号" prop="name">
        {{ form.user.mobile }}
      </el-form-item>

      <el-form-item label="头像" prop="name">
        <img :src="form.user.avatarUrl" width="30px" height="30px"/>
 
      </el-form-item>

      <div class="common-form">用户上传任务详情</div>

      <el-form-item label="备注" prop="name">
        {{ form.note }}
      </el-form-item>

      <el-form-item label="用户上传的图片：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                  </div>
            </div>
          </transition-group>
        </draggable>
      </div>
    </el-form-item>


    <div class="common-form">审核</div>

    <el-form-item label="审核状态" v-if="form.status == 0">
        <el-radio-group v-model="form.status">

          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">不通过</el-radio>
        </el-radio-group>
  
      </el-form-item>

            
    <el-form-item label="审核状态" v-if="form.status != 0">
        <span v-if="form.status == 1">已通过</span>
        <span v-if="form.status == 2">未通过</span>
  
      </el-form-item>


      <el-form-item label="驳回理由" v-if="form.status == 2">
        <div class="edit_container">
          <el-input type="textarea" v-model="form.reject_val"></el-input>
        </div>
      </el-form-item>  



    

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>
</el-dialog>
  
</template>

<script>
import DotaskApi from '@/api/dotask.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        image:"",
        category_id:0,
        sort:50,
        intro:"",
        is_audit:0,
        point:0,//奖励积分
        code:"common",//普通任务
        note:"",
        image:[]
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入做任务名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
         category:[]
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();

  },
  props: ["open_add","dotask_log_id"],
  methods: {
    
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      DotaskApi.detailLog({dotask_log_id: self.dotask_log_id},true).then(res => {
          self.form = res.data;
    
          self.loading = false;
        
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
 
      form.dotask_log_id = self.dotask_log_id;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          DotaskApi.editLog(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        let imgs = e[0].file_path;
        this.form.image = imgs
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },


  }
  
};
</script>

<style>
  .edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/dotask/index/partl/edit.vue